import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
//Components
import JournalNavigation from "../../components/organisms/Journal/Navigation";
//Hocs
import { compose } from "../../services/utilities";
import { hasHash } from "../../services/constants";
//API
import { getAllCategories } from "../../api/requests";
//Context
import { lang as localeLang } from "../../translations";

//TODO: change location.pathname to match from router when # is removed. Push history is needed
function JournalNavigationTemplate({ ...props }) {
  const [state, setState] = useState({
    loading: true,
    error: false,
    data: {}
  });
  //const { lang, categoryId } = match.params;
  const categorySplit = props.location.pathname.split("/");
  const categoryId = Number(categorySplit[3]);
  const lang = localeLang();

  const journalInfo =
    lang === "pt"
      ? {
          route: "noticias",
          magazineLink: `${hasHash}/${lang}/revista-linhas`
        }
      : {
          route: "news",
          magazineLink: `${hasHash}/${lang}/linhas-magazine`
        };

  const onAddUrl = data => {
    let items = data.map(item => {
      return {
        ...item,
        url: `${hasHash}/${lang}/${journalInfo.route}/${item.id}`
      };
    });

    return items;
  };

  const onFetchData = async () => {
    try {
      const res = await getAllCategories({ lang, history: props.history });
      const data = onAddUrl(res.data);

      setState(prevState => {
        return { ...prevState, data, loading: false };
      });
    } catch (error) {
      setState(prevState => {
        return { ...prevState, loading: false, error: true };
      });
    }
  };

  useEffect(() => {
    onFetchData();
  }, []);

  const journalNavigationProps = {
    titleUrl: `${hasHash}/${lang}/${journalInfo.route}`,
    route: journalInfo.route,
    categoryId: categoryId !== "NaN" ? categoryId : 0,
    ...props
  };

  const mobileProps =
    !isNaN(categoryId) && categorySplit.length <= 4
      ? {
          backgroundColor: "#E7E8E9",
          mobileBackgroundColor: "#fff"
        }
      : {};

  return (
    <JournalNavigation
      data={state.data}
      loading={state.loading}
      hasError={state.error}
      magazineLink={journalInfo.magazineLink}
      magazineTitle="Linhas"
      {...mobileProps}
      {...journalNavigationProps}
      hasMobileMdBorderBottom={!isNaN(categoryId) && categorySplit.length >= 4}
      hasMobileBorderBottom={!isNaN(categoryId) && categorySplit.length >= 4}
    />
  );
}

JournalNavigationTemplate.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
};

export default compose(withRouter)(JournalNavigationTemplate);
